export function AccessRoute(routes, accessData) {
  const allowedNames = new Set(accessData.map((item) => item.name));

  const findRouteRecursive = (routes) => {
    for (let route of routes) {
      if (allowedNames.has(route.name)) {
        return route;
      }
      if (route.collapse) {
        const nestedRoute = findRouteRecursive(route.collapse);
        if (nestedRoute) {
          return nestedRoute;
        }
      }
    }
    return null;
  };

  return findRouteRecursive(routes);
}
